export const T = {
  nav: {
    home: "nav-home",
    services: "nav-services",
    about: "nav-about",
    patients: "nav-patients",
    careers: "nav-careers",
    contact: "nav-contact",
    admin: "nav-admin-login",
    menu: "nav-mobile-menu",
  },
  home: {
    hero: "home-hero",
    callUs: "home-call-us-btn",
    contactUs: "home-contact-us-btn",
    serviceCard: (k) => `home-service-${k}`,
    startApp: "home-start-application-btn",
    checkStatus: "home-check-status-btn",
  },
  contact: {
    form: "contact-form",
    name: "contact-name",
    email: "contact-email",
    phone: "contact-phone",
    message: "contact-message",
    submit: "contact-submit",
  },
  careers: {
    startApp: "careers-start-app-btn",
  },
  apply: {
    section: (k) => `apply-section-${k}`,
    prev: "apply-prev-btn",
    next: "apply-next-btn",
    submit: "apply-submit-btn",
    field: (k) => `apply-field-${k}`,
    signaturePad: "apply-signature-pad",
    signatureClear: "apply-signature-clear",
    waiverCheckbox: "apply-waiver-checkbox",
    docUpload: (k) => `apply-doc-upload-${k}`,
    successId: "apply-success-id",
  },
  status: {
    appIdInput: "status-appid-input",
    lastNameInput: "status-lastname-input",
    lookupBtn: "status-lookup-btn",
    result: "status-result",
  },
  admin: {
    codeInput: "admin-code-input",
    loginBtn: "admin-login-btn",
    logout: "admin-logout-btn",
    welcome: "admin-welcome",
    search: "admin-search",
    statusFilter: "admin-status-filter",
    table: "admin-table",
    row: (id) => `admin-row-${id}`,
    open: (id) => `admin-open-${id}`,
    detailStatus: "admin-detail-status",
    detailStatusSave: "admin-detail-status-save",
    detailNoteInput: "admin-detail-note-input",
    detailNoteAdd: "admin-detail-note-add",
    detailBack: "admin-detail-back",
  },
};
